var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.supported_integrations),function(item,index){return _c('li',{key:'bullet:'+index},[(item.on)?_c('span',[_vm._v(" "+_vm._s(item.text)+" ")]):_c('span',{staticStyle:{"color":"rgba(0,0,0,0.5)"}},[_vm._v(" "+_vm._s(item.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }